// Servicio para gestionar el Service Worker

// Función para registrar el service worker
export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | undefined> {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registrado con éxito:', registration.scope);
      
      // Escuchar mensajes del service worker
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
      
      return registration;
    } catch (error) {
      console.error('Error al registrar el Service Worker:', error);
      return undefined;
    }
  } else {
    console.warn('Service Workers no son soportados en este navegador');
    return undefined;
  }
}

// Función para manejar mensajes del service worker
function handleServiceWorkerMessage(event: MessageEvent): void {
  const { type, imagePath } = event.data;
  
  switch (type) {
    case 'IMAGE_FROM_CACHE':
      console.log(`Imagen cargada desde caché: ${imagePath}`);
      // Aquí podrías despachar un evento de Redux o actualizar un contexto
      // para indicar que la imagen se cargó desde caché
      break;
      
    case 'NEW_IMAGE_CACHED':
      console.log(`Nueva imagen cacheada: ${imagePath}`);
      // Aquí podrías actualizar algún contador o indicador
      break;
      
    default:
      // Ignorar mensajes desconocidos
      break;
  }
}

// Función para eliminar la caché de imágenes
export async function clearImageCache(): Promise<void> {
  if ('caches' in window) {
    try {
      await caches.delete('canvasoft-images-v1');
      console.log('Caché de imágenes eliminada');
    } catch (error) {
      console.error('Error al eliminar la caché de imágenes:', error);
    }
  }
}

// Función para verificar si el Service Worker está activo
export async function isServiceWorkerActive(): Promise<boolean> {
  if ('serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.getRegistration();
    return !!registration && !!registration.active;
  }
  return false;
}

// Verificar el tamaño aproximado de la caché de imágenes
export async function getImageCacheSize(): Promise<number> {
  if ('caches' in window) {
    try {
      const cache = await caches.open('canvasoft-images-v1');
      const keys = await cache.keys();
      
      // Obtener el tamaño de cada respuesta
      let totalSize = 0;
      
      for (const request of keys) {
        const response = await cache.match(request);
        if (response) {
          const blob = await response.blob();
          totalSize += blob.size;
        }
      }
      
      return totalSize;
    } catch (error) {
      console.error('Error al obtener el tamaño de la caché:', error);
      return 0;
    }
  }
  return 0;
}